import './Pagination.scss';
import { type Dispatch, type SetStateAction } from 'react';

import { MdFirstPage, MdLastPage, MdOutlineSkipNext, MdOutlineSkipPrevious } from 'react-icons/md';
import { IconButton } from '../IconButton';
import { Appearance } from '../designConstants';

interface PaginationProps {
  limit?: number;
  offset: number;
  totalData: number;
  updateOffset: Dispatch<SetStateAction<number>>;
}

export const Pagination = ({ limit = 10, offset, totalData, updateOffset }: PaginationProps) => (
  <div className='pagination-row'>
    <IconButton
      disabled={!(offset > 0)}
      appearance={Appearance.OUTLINED}
      className='first-page-button'
      onClick={() => {
        updateOffset(0);
      }}
    >
      <MdFirstPage />
    </IconButton>
    <IconButton
      disabled={!(offset > 0)}
      appearance={Appearance.OUTLINED}
      className='previous-button'
      onClick={() => {
        if (offset - limit > 0) {
          updateOffset(offset - limit);
        } else {
          updateOffset(0);
        }
      }}
    >
      <MdOutlineSkipPrevious />
    </IconButton>
    <div className='pagination-data-shown'>
      <div>{totalData === 0 ? 0 : offset + 1} to </div>
      <div>{offset + limit <= totalData ? offset + limit : totalData} of </div>
      <div>{totalData}</div>
    </div>
    <IconButton
      disabled={offset + limit >= totalData}
      appearance={Appearance.OUTLINED}
      className='next-button'
      onClick={() => {
        updateOffset(offset + limit);
      }}
    >
      <MdOutlineSkipNext />
    </IconButton>
    <IconButton
      disabled={offset + limit >= totalData}
      appearance={Appearance.OUTLINED}
      className='next-button'
      onClick={() => {
        updateOffset(totalData - limit);
      }}
    >
      <MdLastPage />
    </IconButton>
  </div>
);
